import Interieur from "./Interieur";
import Schublade from "./Schublade";
import ClosedInterval from "oc-commons/ClosedInterval";
import Maths from "oc-commons/Maths";
import Brett from "./Brett";

export default class Schubladenbox extends Interieur {
    // DO NOT CHANGE
    className = "Schubldenbox";

    // persistent (UserLayer) ------------------------------------------

    faecherAnzahl = 1;
    faecherHoehe = 20; // Das ist die FRONTHOEHE - auch bei innenliegenden (die keine Front haben).
    isDropped = false;

    // transient (CompiledLayer) ---------------------------------------

    drawers = [];
    abstandsbretter: Brett[] = [];

    insets = {
        top: 2,
        bottom: 2,
    };

    ueberstand = {
        top: 0,
        bottom: 0,
    }

    frontBox = new THREE.Box3();

    _copied = false;

    constructor(type, element) {
        super(type, element);
    }

    get hasFronts() {
        return 'innenliegend' !== this.product.Art;
    }

    // canOverlay(other:Interieur) {
    //     return other===this || !(this.hasFronts && other.hasFronts);
    // }

    get hasGriffe() {
        return 'innenliegend' !== this.product.Art;
    }

    get interieur() {
        return this;
    }

    getFrontOffset() {
        const aufschlagend = this.schrank.options.getFloat('aussenwand_vorsprung') == 0.0;
        return aufschlagend ? this.schrank.options.getFloat('brett_staerke') : 0;
    }

    getPrice() {
        let price = 0.0;
        const brettZuschlag = APP.settings.fixPreis.Bretter;
        const drillteqZuschlagKonstruktionsboden = APP.settings.fixPreis.DrillteqKonstruktionsboden;
        const qmPreis = APP.settings.fixPreis.standardQmPreis;

        const schrankSize = {
            x: this.schrank.size.x, 
            y: this.schrank.size.y, 
            z: this.schrank.size.z
        };

        const findZarge = () => {
            let sliceIndex = 0;
            const zargensets = APP.findProductVariancesMatching("Zargenschienenset");

            const zargenSortedByDepth = _.orderBy(zargensets, "abTiefe", "desc");
            sliceIndex = zargenSortedByDepth.findIndex(z => z.abTiefe <= schrankSize.z);
            const zargenMatchingDepth = zargenSortedByDepth.slice(sliceIndex < 0 ? 0 : sliceIndex);
            if(sliceIndex == -1) {
                APP.model.maybeThrowCompileError(this, I18N("kein Zargenset"), I18N("kein Zargenset gefunden"));
            }

            const zargenSortedByHeight = _.sortBy(zargenMatchingDepth, ["abTiefe","abHöhe"], ["desc", "desc"]);
            sliceIndex = zargenSortedByHeight.findLastIndex(z => z.abHöhe <= this.faecherHoehe);
            const zargenMatchingHeight = zargenSortedByHeight.slice(sliceIndex < 0 ? 0 : sliceIndex);
            if(sliceIndex == -1) {
                APP.model.maybeThrowCompileError(this, I18N("kein Zargenset"), I18N("kein Zargenset gefunden"));
            }
            
            return zargenMatchingHeight[0] || null;
        }

        if(this.type == "Schubladenbox") {
            price += APP.findProduct(this.product.Artikelnummer, false, schrankSize )?.PreisStandard || 0.0;
            const zarge = findZarge();
            if(zarge) {
                price += zarge.PreisStandard
                console.log(zarge.abTiefe, zarge.abHöhe);
            } else {
                console.warn("Zargenset NOT FOUND");
            }

            price += this.boden.bottom.getPrice(qmPreis) || 0.0;
            this.drawers.forEach( d => {
                price += d.inner?.getPrice(qmPreis) || 0.0;
                price += d.front?.getPrice() || 0.0;
                console.log("Front: ", d.front.getQm().toFixed(3), "qm, ", d.front.getPrice()/100, "EUR");
            });

            if(this.boden.top?.isInner) {
                price += this.boden.top.getPrice() + brettZuschlag + drillteqZuschlagKonstruktionsboden;
            }
            if(this.boden.bottom?.isInner) {
                price += this.boden.bottom.getPrice() + brettZuschlag + drillteqZuschlagKonstruktionsboden;
            }
        }
        return Math.round(price);
    }

    addToElement(...element) {
        /* if(element) {
            const schubladenMax = element.schrank.options.getMaxValue('schublade_hoehe');
            const schubladenMin = element.schrank.options.getMinValue('schublade_hoehe');
            const schubladenDefault = element.schrank.options.getFloat('schublade_hoehe');
            if(schubladenDefault >= schubladenMin && schubladenDefault <= schubladenMax) {
                console.log(schubladenDefault);
                this.setFaecher(this.faecherAnzahl, schubladenDefault)
            }
        } */
        super.addToElement(...element);
    }

    fromJSON(json) {
        super.fromJSON(json);
        this.faecherAnzahl = json.faecherAnzahl || 1;
        this.faecherHoehe = json.faecherHoehe || 20;
        this.isDropped = true;
        return this;
    }

    toJSON() {
        const json = super.toJSON();
        json.faecherAnzahl = this.faecherAnzahl;
        json.faecherHoehe = this.faecherHoehe;
        json.griffArtikel = APP.arrangement.griffArtikelnummer;
        // Ausrichtung später vlt dynamisch? // senkrecht / waagerecht
        json.griffAusrichtung = "waagerecht";
        json.className = this.className;
        return json
    }

    copy(schubladenbox,createInterceptor) {
        super.copy(schubladenbox,createInterceptor);
        this.faecherAnzahl = schubladenbox.faecherAnzahl;
        this.faecherHoehe = schubladenbox.faecherHoehe;
        this.isDropped = schubladenbox.isDropped;
        // this._copied = true;
        return this;
    }

    _compileSize() {
        super._compileSize();

        const layout = this._getLayout();
        this.ueberstand = layout.ueberstand;
        this.size.y = layout.hoehe;
        //this.size.z -= this.element.getInterieurMinZ(this.y, this.y + this.size.y);

        // Fix Me?
        /* if (this.element && this.element.konstruktionsboeden && (this.size.y - 0.01) > this.element.size.y) {
            const newSize = this.calcFaecherHoehe(this.faecherAnzahl, this.faecherHoehe);
            this.setFaecher(newSize.anzahl, newSize.hoehe);
        } */
    }

    getHeight(bottom, top) {
        return this._getHeight(bottom, top).hoehe;
    }

    compileInternals() {
        super.compileInternals();
        if (this.element) {
            //looks strange but fixes some Problems with Schubladen in elements with Mittelwand
            this.setFaecher(this.faecherAnzahl, this.faecherHoehe);
        }
        const fuge = this.schrank.options.getFloat('fugen_abstand');
        const brettStaerke = this.schrank.options.getFloat('front_staerke');
        const lazyDrawers = APP.model.lazyPool(this, 'drawers', () => new Schublade(this));

        // Die Koordinaten der Schublade sind im lokalen Koordinatensystem der Schubladenbox

        // Zu innenliegenden SK:
        // Wenn der Schubkasten eine Höhe von 200mm hat, ist das inkl. 30 mm Eingrifffuge.
        // Unten kommen noch 4 mm Fuge des unteren Schubkastens zum Boden hin dazu.
        // Bei 4 Schubkästen ist das Zwischenmaß also 4 x 200mm + 4mm Fuge unten = 804mm.

        let drawerBox = this.boxLocal;

        this._compileAbstandsbretter(drawerBox);

        let drawerOuterHeight = this.hasFronts
            ? (
                this.size.y
                + (this.ueberstand.bottom + this.ueberstand.top)
                - (fuge * (this.faecherAnzahl-1))
              ) / this.faecherAnzahl
            : ( this.size.y - fuge ) / this.faecherAnzahl;

        let yOuter = this.hasFronts ? -this.ueberstand.bottom : fuge;

        _.range(this.faecherAnzahl).forEach(i => {
            const drawer = lazyDrawers.next();

            drawer.front.box.copy(drawerBox);

            drawer.front.box.min.y = yOuter;
            yOuter += drawerOuterHeight;
            drawer.front.box.max.y = yOuter;
            yOuter += this.hasFronts ? fuge : 0;

            drawer.inner.box.copy(drawerBox);
            drawer.inner.box.max.z -= this.schrank.options.getFloat('aussenwand_vorsprung');

            const innerMinY = drawerBox.min.y+this.insets.bottom;
            const innerMaxY = drawerBox.max.y-this.insets.top;
            drawer.inner.box.min.y = Maths.cutBetween(innerMinY,drawer.front.box.min.y+this.insets.bottom,innerMaxY);
            drawer.inner.box.max.y = Maths.cutBetween(innerMinY,drawer.front.box.max.y-this.insets.top,innerMaxY);

            if (this.hasFronts) {
                if (this.element) {
                    drawer.front.box.min.x = drawer.schubladenbox.getFrontUeberstand(drawer.element.wallLeft, 'min', 'x');
                    drawer.front.box.max.x = drawer.schubladenbox.getFrontUeberstand(drawer.element.wallRight, 'max', 'x');
                }
            } else {
                let leftOffset = brettStaerke;
                let rightOffset = brettStaerke;
                if (this.element && this.element.getDoors().length > 0) {
                    if (this.element.getDoors().some(d=>d.getSide() === 'links' || d.getSide() === 'beide')) {
                        leftOffset += brettStaerke;
                    }
                    if (this.element.getDoors().some(d=>d.getSide() === 'rechts' || d.getSide() === 'beide')) {
                        rightOffset += brettStaerke;
                    }
                }
                drawer.inner.box.min.x += (this.schrank.options.getFloat('schublade_innen_seitlich') + leftOffset);
                drawer.inner.box.max.x -= (this.schrank.options.getFloat('schublade_innen_seitlich') + rightOffset);
                drawer.inner.box.max.y -= (this.schrank.options.getFloat('schublade_innen_eingriff'));
                drawer.inner.box.max.z -= (this.schrank.options.getFloat('schublade_innen_ruecksprung') + brettStaerke);

                drawer.front.box.min.x = drawer.inner.box.min.x - brettStaerke;
                drawer.front.box.max.x = drawer.inner.box.max.x + brettStaerke;
                drawer.front.box.max.y -= (this.schrank.options.getFloat('schublade_innen_eingriff'));
            }

            drawer.front.box.min.z = drawer.inner.box.max.z;
            drawer.front.box.max.z = drawer.inner.box.max.z + brettStaerke;

            drawer.inner.boxToVertices();
            drawer.front.boxToVertices();

            drawer.isTop = i === this.faecherAnzahl - 1;
            drawer.isBottom = i === 0;
        });
        lazyDrawers.cleanup();
        this.drawers.forEach(x => x.compile());
    }

    _compileAbstandsbretter(drawerBox) {
        if (this.hasFronts ||
            !this.schrank.isSchwebetuer ||
            !this.element) {
            return;
        }

        const brettStaerke = this.schrank.options.getFloat('brett_staerke');
        const schwebetuer_schubkasten_innenliegend_seitenabstand = this.schrank.options.getFloat('schwebetuer_schubkasten_innenliegend_seitenabstand',5);

        const abstandsbretter = APP.model.lazyPool(this, 'abstandsbretter', () => {
            const brett = new Brett(this, 'Abstandsbrett', 'yz');
            return brett;
        });

        ['wallLeft','wallRight'].forEach(wall=>{
            if (!this.element[wall].isInner || this.element[wall].product.Artikelnummer === 'Trennwand') {
                return;
            }
            const left = wall === 'wallLeft';
            const abstandsbrett = abstandsbretter.next();
            if (left) {
                drawerBox.min.x += (schwebetuer_schubkasten_innenliegend_seitenabstand + brettStaerke);
            } else {
                drawerBox.max.x -= (schwebetuer_schubkasten_innenliegend_seitenabstand + brettStaerke);
            }
            abstandsbrett.box.copy(drawerBox);
            if (left) {
                abstandsbrett.box.min.x = drawerBox.min.x - brettStaerke;
                abstandsbrett.box.max.x = drawerBox.min.x;
            } else {
                abstandsbrett.box.min.x = drawerBox.max.x;
                abstandsbrett.box.max.x = drawerBox.max.x + brettStaerke;
            }
            abstandsbrett.boxToVertices();
            abstandsbrett.compile();
        });

        abstandsbretter.cleanup();
    }

    compileFront() {
        this.drawers.forEach(x => x.compileFront());
        this.frontBox.makeEmpty();
        this.drawers.forEach(x => this.frontBox.union(x.front.box));
    }

    setFromProduct(product) {
        this.product = product;
        this.drawers = [];
        this.abstandsbretter = [];

        this.compile();
        this.compileInternals();
        this.compileFront();
        APP.model.setDirty();
    }

    get maxFaecher() {
        if (!this.element) {
            return 0;
        }
        const fuge = this.schrank.options.getFloat('fugen_abstand');
        const fit = this.element.getInterieurYFitAtPos(this);
        if(!fit)return 0;
        return (fit.maxCollapse - fit.minCollapse) / (this.schrank.options.getMinValue('schublade_hoehe') + fuge);
    }


    setFaecher(anzahl, hoehe) {
        const calc = this.calcFaecherHoehe(anzahl, hoehe);
        if (calc == null ){
            return;
        }
        if (calc.anzahl===0) {
            APP.model.maybeThrowCompileError(this,'Keine passende Schublade', 'Es gibt für dieses Fach keine passende Schubladenbox');
        }
        this.faecherAnzahl = calc.anzahl;
        this.faecherHoehe = calc.hoehe;
        this._compileSize();
        const fit = this.element.getInterieurYFitAtPos(this);
        const freieFachHoehe = this.schrank.options.getFloat('fach_hoehe');
        const zuTief = fit.minCollapse - this.getSchrankY();
        if (zuTief > -freieFachHoehe) {
            this.setSchrankY(fit.minCollapse);
        }
        this._compileSize();
        /**
         * ---  Hier wird geprüft ob die aufaddierten Fächer größer sind als maxCollapse - minCollapse
         *      Wenn dem so ist, dann muss die Schubladenbox-Position mittig positioniert werden.
         * ---  Wenn dann die Schubladenbox ganz oben angelegt ist, wird noch eine Korrektur ähnlich der
         *      zuTief Logik angewandt (s.o.)
         */
        const buffer = this.getSchrankY() + this.size.y - fit.maxCollapse;
        const zuHoch = this.faecherAnzahl * this.faecherHoehe > fit.maxCollapse - fit.minCollapse
        if(zuHoch) {
            this.setSchrankPositionY((fit.maxCollapse + fit.minCollapse) / 2);
        } else if (buffer > -freieFachHoehe) {
            this.setSchrankPositionY(this.getSchrankPositionY() - buffer);
        }
    }

    /**
     * Gibt die realisierbare Hoehe und Anzahl zurück. Die Anzahl wird möglichst beibehalten.
     * @param anzahl
     * @param wunschhoehe
     * @returns {anzahl,hoehe}
     */
    calcFaecherHoehe(anzahl, wunschhoehe) {
        if (!this.element) {
            return;
        }

        const epsilon = 0.0001;
        const fuge = this.schrank.options.getFloat('fugen_abstand');
        const fit = this.element.getInterieurYFitAtPos(this);
        // Hier gibt es eine Reihe von Bedingungen zu beachten
        // - min/max Werte für die Höhe einer einzelnen Schublade
        // - kollabierender Bereich oben und/oder unten
        // - Fach-Mindesthöhen
        // - Höhe der Front ist abhängig von angrenzendem Deckel oder Boden
        // - die Position der Schublade sollte nach Möglichkeit beibehalten werden

        // Es muss also sowohl die Position als auch die Höhe beachtet werden, und es gibt Sprünge.
        // Das Einpassen der Höhe hat Priorität von der Position.
        // Die Position wird von dieser Methode nicht ermittelt, nur, ob es überhaupt eine gültige Höhe (und Anzahl) gibt

        if(!fit)return;
        const touchBox = this.element.localToSchrankBox(this.element.box);
        const touches = {
            bottom: Math.abs(fit.minCollapse - touchBox.min.y) < epsilon,
            top: Math.abs(fit.maxCollapse - touchBox.max.y) < epsilon,
        }
        const ueberstand = {
            collapsed: this._getUeberstand(touches.bottom, touches.top),
            uncollapsed: this._getUeberstand(false, false),
        }
        const collapseSpace = {
            bottom: fit.min - fit.minCollapse,
            top: fit.maxCollapse - fit.max,
        }
        const innerHoehe = fit.max - fit.min;

        // Die folgenden Intervalle geben die erlaubten von-bis Bereiche der Front-Höhe der gesamten Schubladenbox inklusiv Überstand an
        // Die Fach-Höhen werden dadurch grundsätzlich berücksichtigt, unter der Voraussetzung, dass die Position
        // nachträglich richtig gesetzt wird
        const frontHeightIntervals = [];
        // 1. Fall - Passt komplett rein, dadurch ist die position festgelegt: muss oben und unten anschliessen
        frontHeightIntervals.push([
            collapseSpace.bottom + collapseSpace.top + innerHoehe + ueberstand.collapsed.bottom + ueberstand.collapsed.top,
            collapseSpace.bottom + collapseSpace.top + innerHoehe + ueberstand.collapsed.bottom + ueberstand.collapsed.top]);
        // 2. Fall - position festgelegt: muss unten anschliessen
        frontHeightIntervals.push([
            collapseSpace.bottom + ueberstand.collapsed.bottom + ueberstand.uncollapsed.top,
            collapseSpace.bottom + innerHoehe + ueberstand.collapsed.bottom + ueberstand.uncollapsed.top]);
        // position festgelegt: muss oben anschliessen
        frontHeightIntervals.push([
            collapseSpace.top + ueberstand.uncollapsed.bottom + ueberstand.collapsed.top,
            collapseSpace.top + innerHoehe + ueberstand.uncollapsed.bottom + ueberstand.collapsed.top]);
        // position frei innerhalb der innerHoehe-hoehe
        frontHeightIntervals.push([0, innerHoehe + ueberstand.uncollapsed.bottom + ueberstand.uncollapsed.top]);

        // Rückrechnung von einer Gesamthöhe auf die Höhe einer einzelnen Schublade
        const einzelHoeheBeiGesamterFrontHeight =
                this.hasFronts
                    ? h => (h - (anzahl - 1) * fuge) / anzahl
                    : h => (h - fuge) / anzahl;


        // Die Intervalle auf gültige Schubladenhöhen begrenzen
        const schubladenHoeheInterval = [this.schrank.options.getMinValue('schublade_hoehe'),this.schrank.options.getMaxValue('schublade_hoehe')];
        const singleHeightIntervals = frontHeightIntervals.map(i=>{
            const einzelHoeheIntervall = i.map(h=>einzelHoeheBeiGesamterFrontHeight(h));
            return ClosedInterval.intersection(schubladenHoeheInterval,einzelHoeheIntervall);
        }).filter(i=>i!=null);

        // Wenn es kein gültiges Intervall gibt, tja... dann wohl leider nicht. Wir probieren es mit einer anderen Anzahl
        // an Schubladen rekursiv noch mal
        if (singleHeightIntervals.length===0) {
            if (anzahl>1) {
                const result = this.calcFaecherHoehe(anzahl-1, wunschhoehe);
                if (result) {
                    return result;
                }
            }
            if (anzahl<innerHoehe/schubladenHoeheInterval[0]) {
                const result = this.calcFaecherHoehe(anzahl+1, wunschhoehe);
                if (result) {
                    return result;
                }
            }
            return {anzahl: 0, hoehe: 0};
        }

        // Wenn die Wunschhöhe in einem der Intervalle liegt => passt!
        if (singleHeightIntervals.some(i=>i[0]-epsilon<=wunschhoehe && wunschhoehe<=i[1]+epsilon)) {
            return {anzahl, hoehe: wunschhoehe};
        }

        // Ansonsten ändere die Höhe auf die nächste Intervallgrenze
        const grenzen = _.flatten(singleHeightIntervals);
        const intervallgrenze = _.minBy(grenzen,h=>Math.abs(h-wunschhoehe));
        return {anzahl, hoehe: intervallgrenze};
    }

    _getLayout(anzahl = this.faecherAnzahl, hoehe = this.faecherHoehe, y = this.y) {
        // falls die Schublade zu hoch sitzt, wird sie vorab nach unten verschoben
        // wichtig für die Anwendung im Dialog.
        const fuge = this.schrank.options.getFloat('fugen_abstand');
        const brettStaerke = this.schrank.options.getFloat('brett_staerke');

        /* const fit = this.element.getInterieurYFitAtPos(this);
        const touches = {
            bottom: Math.abs(fit.minCollapse - this.element.box.min.y) < epsilon,
            top: Math.abs(fit.maxCollapse - this.element.box.max.y) < epsilon,
        } */

        // FIXME das ist aber nur für die Aussenliegende Schublade gültig, oder?
        const frontHoehe = anzahl * hoehe + (anzahl - 1) * fuge;

        /* if (this.element) {
            const zuHoch = y + frontHoehe - brettStaerke - this.element.slopeTop;
            if (zuHoch > 0) {
                y -= zuHoch;
            }
        } */

        const EPSILON = brettStaerke*2;

        const bottom = !this.element || y <= this.element.box.min.y + EPSILON;
        const top = !this.element || y - this.ueberstand.bottom + frontHoehe > this.element.box.max.y - EPSILON;
        return this._getHeight(bottom, top, anzahl, hoehe);
    }

    /**
     * Berechnet die Höhe der Schubladenbox abhängig davon, ob sie an Boden oder Deckel angrenzt
     * (und daher andere Überstände und damit eine andere Höhe hat). Ergebnis:
     * {ueberstandBottom, ueberstandTop, hoehe}
     */
    _getHeight(bottom: boolean, top: boolean, anzahl = this.faecherAnzahl, hoehe = this.faecherHoehe) {
        const result = {
            ueberstand: this._getUeberstand(bottom, top),
            hoehe: 0
        };
        
        const fuge = this.schrank.options.getFloat('fugen_abstand');

        if (this.hasFronts) {
            result.hoehe = anzahl * hoehe + (anzahl - 1) * fuge - result.ueberstand.bottom - result.ueberstand.top;
        } else {
            // Zu innenliegenden SK:
            // Wenn der Schubkasten eine Höhe von 200mm hat, ist das inkl. 30 mm Eingrifffuge.
            // Unten kommen noch 4 mm Fuge des unteren Schubkastens zum Boden hin dazu.
            // Bei 4 Schubkästen ist das Zwischenmaß also 4 x 200mm + 4mm Fuge unten = 804mm.
            result.hoehe = anzahl * hoehe + fuge;
        }
        return result;
    }

    _getUeberstand(bottom: boolean, top: boolean) {

        if (!this.hasFronts) {
            return {
                bottom: 0,
                top: 0,
            }
        }

        const fuge = this.schrank.options.getFloat('fugen_abstand');
        const brettStaerke = this.schrank.options.getFloat('brett_staerke');
        const ueberstandUnten = this.schrank.options.getFloat('ueberstand_aussen_unten');
        const ueberstandOben = this.schrank.options.getFloat('ueberstand_aussen_oben');
        const aufschlagend = this.schrank.options.getFloat('aussenwand_vorsprung') === 0.0;
        const bodenStaerke = this.schrank.options.getFloat('boden_staerke');
        const deckelStarke = this.schrank.options.getFloat('deckel_staerke');

        return {
            bottom: bottom
                ? bodenStaerke - ueberstandUnten
                : (brettStaerke - fuge) / 2,
            top: top
                ? (aufschlagend ? deckelStarke - ueberstandOben : -fuge)
                : (brettStaerke - fuge) / 2
        }
       
    }

    // für partslist/Preisberechnung - Mass einer einzelnen Schublade
    get flaechenMass() {
        const result = this.size.clone();
        result.y = this.faecherHoehe;
        return result;
    }

    iterate(iterator) {
        super.iterate(iterator);
        this.drawers.forEach(x=>x.iterate(iterator));
        this.abstandsbretter.forEach(x=>x.iterate(iterator));
    }

}


